var _rect, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTinyChatTriangleRight = function SvgTinyChatTriangleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -439.5,
    y: 0.5,
    width: 451,
    height: 138,
    rx: 9.5,
    fill: "#1C1C1E",
    stroke: "#2C2C2E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_12040_32129",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-430 0H-407.001H-20.9995H1.99979H19.5251C21.2542 0 22.1685 2.04577 21.0153 3.334L11.9998 13.4045V129C11.9998 134.523 7.52264 139 1.99979 139H-430C-435.523 139 -440 134.523 -440 129V13.4043L-449.015 3.334C-450.169 2.04577 -449.254 0 -447.525 0H-430Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-430 0H-407.001H-20.9995H1.99979H19.5251C21.2542 0 22.1685 2.04577 21.0153 3.334L11.9998 13.4045V129C11.9998 134.523 7.52264 139 1.99979 139H-430C-435.523 139 -440 134.523 -440 129V13.4043L-449.015 3.334C-450.169 2.04577 -449.254 0 -447.525 0H-430Z",
    fill: "#1C1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0153 3.334L21.7603 4.001L21.7603 4.001L21.0153 3.334ZM11.9998 13.4045L11.2547 12.7375L10.9998 13.0223V13.4045H11.9998ZM-440 13.4043H-439V13.022L-439.255 12.7373L-440 13.4043ZM-449.015 3.334L-449.761 4.001L-449.015 3.334ZM-430 1H-407.001V-1H-430V1ZM-407.001 1H-20.9995V-1H-407.001V1ZM-20.9995 1H1.99979V-1H-20.9995V1ZM1.99979 1H19.5251V-1H1.99979V1ZM19.5251 1C20.3897 1 20.8469 2.02289 20.2702 2.667L21.7603 4.001C23.4902 2.06864 22.1187 -1 19.5251 -1V1ZM20.2702 2.667L11.2547 12.7375L12.7448 14.0715L21.7603 4.001L20.2702 2.667ZM10.9998 13.4045V129H12.9998V13.4045H10.9998ZM10.9998 129C10.9998 133.971 6.97036 138 1.99979 138V140C8.07493 140 12.9998 135.075 12.9998 129H10.9998ZM1.99979 138H-430V140H1.99979V138ZM-430 138C-434.971 138 -439 133.971 -439 129H-441C-441 135.075 -436.075 140 -430 140V138ZM-439 129V13.4043H-441V129H-439ZM-449.761 4.001L-440.745 14.0713L-439.255 12.7373L-448.27 2.667L-449.761 4.001ZM-447.525 -1C-450.119 -1 -451.49 2.06865 -449.761 4.001L-448.27 2.667C-448.847 2.02289 -448.39 1 -447.525 1V-1ZM-430 -1H-447.525V1H-430V-1Z",
    fill: "#2C2C2E",
    mask: "url(#path-2-inside-1_12040_32129)"
  })));
};
export { SvgTinyChatTriangleRight as ReactComponent };
export default __webpack_public_path__ + "tiny-chat-triangle-right.svg";